'use client'

import React from 'react'

import { WalkingIconLottie } from '@podo/assets'

import { ClientOnly, Overlay } from '../'

export const GlobalLoading = () => {
  return (
    <ClientOnly>
      <Overlay clickable={false} />
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[60]">
        <WalkingIconLottie loop play className="w-[108px] h-[108px]" />
      </div>
    </ClientOnly>
  )
}

export const GlobalLoadingBoundary = ({ children, isLoading }: { children?: React.ReactNode; isLoading: boolean }) => {
  return (
    <React.Fragment>
      {isLoading && <GlobalLoading />}
      {children}
    </React.Fragment>
  )
}
